import { browserStorage } from './cache/browserStorage';
import { ErrorReason } from './errorMessages';

export const ssoErrorToReason = (error: any): ErrorReason => {
    const code = error?.response?.status;
    if (error.code === 'ERR_NETWORK') {
        return 'network-error';
    } else if (code === 400) {
        return 'invalid-sso-url';
    } else if (code === 403) {
        return 'sso-not-allowed';
    } else if (code === 404) {
        return 'user-not-found';
    } else if (code === 429) {
        return 'too-many-attempts';
    } else {
        return 'unknown';
    }
};

export const isAuthenticatedWithSSO = () => {
    const token = browserStorage.loadAuthToken();
    const isSSOToken = token && 'domain' in token;
    return Boolean(isSSOToken && token.domain);
};

export const isAuthorizationCodeRedirect = (query: URLSearchParams) => {
    return query.get('state') || query.get('code') || query.get('error');
};
